/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-underscore-dangle */
import { useState, useEffect, useReducer, useContext } from 'react';

import UserSessionContext from 'context/UserSessionContext';
import request, { setAuthHeader, setTimestampHeader, logError } from 'utils/request';
import { useLogout } from 'hooks/useAuth';
import handleErrorMessages from 'hooks/useApi/useApiHelpers/handleErrorMessages';
import useNavigate from 'hooks/useNavigate';
import dataFetchReducer from './apiReducer';

export default (initialReqParams, initialData) => {
  const [reqParams, setReqParams] = useState(initialReqParams);
  const [state, dispatch] = useReducer(dataFetchReducer, {
    isLoading: false,
    isError: false,
    data: initialData,
    error: null
  });

  const { session } = useContext(UserSessionContext);
  const { isLoggedIn } = session;

  const navigate = useNavigate();

  const [logout] = useLogout();

  useEffect(() => {
    let didCancel = false;

    if (reqParams) {
      (async () => {
        dispatch({ type: 'FETCH_INIT' });

        try {
          const result = await request(reqParams);
          const resultHasJwtToken = result.data && result.data.token;
          const resultHasTimestampHeader = result.headers && result.headers.timestamp;

          if (!didCancel) {
            if (resultHasJwtToken) {
              setAuthHeader(resultHasJwtToken);
            }
            if (resultHasTimestampHeader) {
              setTimestampHeader(resultHasTimestampHeader);
            }
            dispatch({ type: 'FETCH_SUCCESS', payload: result.data });
          }
        } catch (error) {
          logError(error);
          const errorMessage = handleErrorMessages(error);
          if (!didCancel) {
            dispatch({ type: 'FETCH_FAILURE', error: errorMessage });
          }
          if (error.response && error.response.status === 401 && isLoggedIn) {
            logout();
          }
          if (error.response && error.response.status === 403 && isLoggedIn) {
            navigate('/');
          }
        }
      })();
    }
    return function cleanup() {
      didCancel = true;
    };
  }, [reqParams]);

  return [state, setReqParams];
};
